import React, {useState} from 'react';
import ModelViewerTile from "./ModelViewerTile";
import {RightOutlined} from "@ant-design/icons";
import {Button, Divider, Input, message, Progress, Typography} from "antd";
import FakeProgress from "fake-progress";
import axios from "axios";
import {GLOBAL_CONFIG} from "../../tools/global_config";
import {GLTFExporter} from "three/addons/exporters/GLTFExporter";

const PartGenerationComponent = ({name, anyPartGenerating, setAnyPartGenerating}) => {
    const [generating, setGenerating] = useState(false);
    const [prompt, setPrompt] = useState("");
    const [progress, setProgress] = useState(0);

    var FakeProgress = require("fake-progress");

    const onGenerateTap = async () => {
        var p = new FakeProgress({
            timeConstant : 3000,
            autoStart : true
        });
        setGenerating(true);
        setAnyPartGenerating(true);

        var onEachSecond = function(){
            setProgress(p.progress);
        };

        var interval = setInterval(onEachSecond, 100);

        function timeout(delay) {
            return new Promise( res => setTimeout(res, delay) );
        }

        await timeout(12000);

        var t1 = performance.now();
        p.end();
        clearInterval(interval);
        setProgress(1);
        await timeout(500);
        setGenerating(false);
        setAnyPartGenerating(false);
        setProgress(0);
    };

    return (
       <div className="flex items-center gap-8 h-fit">
           <div className="text-2xl text-left w-48">{name}</div>
           <Button
               type="primary"
               shape="round"
               style={{fontFamily: "Avenir", width: "12rem", height: "3rem", fontSize: 18}}
               onClick={() => {
                   // TODO: highlight
               }}
           >
               Highlight
           </Button>
           <Input
               placeholder={"Describe how this part should look like"}
               style={{textColor: "black", fontSize: 16, borderRadius: "1rem"}}
               autoSize={true}
               onChange={(e) => {
                   setPrompt(e.target.value)
               }}
           />
           <Button
               type="primary"
               shape="round"
               loading={generating}
               disabled={prompt.length === 0 || (anyPartGenerating && !generating)}
               style={{fontFamily: "Avenir", width: "12rem", height: "3rem", fontSize: 18}}
               onClick={() => {
                   onGenerateTap();
               }}
           >
               Generate
           </Button>
           {
               generating ?
                   <Progress percent={Math.round(progress * 100)}/>
                   : <div/>
           }
       </div>
    );
}

const PartialTexturing = () => {
    const [anyPartGenerating, setAnyPartGenerating] = useState(false);
    const [download, setDownload] = useState({});
    const [globalMesh, setGlobalMesh] = useState(null);

    var link = document.createElement( 'a' );
    link.style.display = 'none';
    document.body.appendChild( link );
    const downloadModel = () => {
        const exporter = new GLTFExporter();
        const options = {};

        function save( blob, filename ) {

            link.href = URL.createObjectURL( blob );
            link.download = filename;
            link.click();

            // URL.revokeObjectURL( url ); breaks Firefox...

        }

        function saveString( text, filename ) {

            save( new Blob( [ text ], { type: 'model/gltf+json' } ), filename );

        }

        function downloadJSON( json, filename ) {

            saveString( JSON.stringify( json ), filename );

        }

        exporter.parse(
            globalMesh,
            function ( gltf ) {
                downloadJSON( gltf, "model.glb" );
            },
            function ( error ) {
                message.error("Failed to export");
            },
            options
        );
    }

    return (
        <div className="h-screen" style={{fontFamily: "Avenir"}}>
            <div className="flex my-8 gap-16 mx-16">
                <ModelViewerTile
                    width={"32rem"}
                    height={"90vh"}
                    glbPath={"3d-assets/sword/sword_0.glb"}
                    showDownload={false}
                    setGlobalMesh={setGlobalMesh}
                />;
                <div className="flex flex-col place-content-center gap-12 my-8">
                    <div className="text-left font-bold text-xl">The asset is divided into several parts.<br/>
                        You can texture any part of your choice by entering the desired result description and clicking "Generate". <br/>
                        To ensure that you are changing a wanted part click "Highlight" and this part will become red.
                    </div>
                    <PartGenerationComponent name="Handle" anyPartGenerating={anyPartGenerating} setAnyPartGenerating={setAnyPartGenerating}/>
                    <PartGenerationComponent name="Blade" anyPartGenerating={anyPartGenerating} setAnyPartGenerating={setAnyPartGenerating}/>
                    <PartGenerationComponent name="Crystal" anyPartGenerating={anyPartGenerating} setAnyPartGenerating={setAnyPartGenerating}/>

                    <Divider/>

                    <div className="flex justify-center items-center gap-8 h-fit">
                        <Button
                            type="primary"
                            shape="round"
                            style={{fontFamily: "Avenir", width: "12rem", height: "3rem", fontSize: 18}}
                            onClick={() => {
                                downloadModel();
                            }}
                        >
                            Download
                        </Button>
                        <Button
                            type="primary"
                            shape="round"
                            style={{fontFamily: "Avenir", width: "12rem", height: "3rem", fontSize: 18}}
                            onClick={() => {
                                message.info("All prompts and textures cleared.")
                                //TODO: reset
                            }}
                        >
                            Reset
                        </Button>
                        <Button
                            type="primary"
                            shape="round"
                            style={{fontFamily: "Avenir", width: "12rem", height: "3rem", fontSize: 18}}
                            onClick={() => {
                                message.info("Coming soon");
                            }}
                        >
                            Upload my asset
                        </Button>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default PartialTexturing;